import { render } from "./ImageCanvas.vue?vue&type=template&id=65db8dc4&ts=true"
import script from "./ImageCanvas.vue?vue&type=script&lang=ts"
export * from "./ImageCanvas.vue?vue&type=script&lang=ts"

import "./ImageCanvas.vue?vue&type=style&index=0&id=65db8dc4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__